<template>
  <DefaultPage id="about">
    <div class="hero hero--purple">
      <div class="grid-container">
            <div class="panel" data-aos="fade"
                           data-aos-duration="1000">
                <div class="panel__item panel__item--centered grid-x grid-margin-x align-center">
                    <div class="panel__item__headline cell medium-6">
                        <h1 class="panel__item__headline__title panel__item__headline__title--hero">
                            Protect, Support <br class="show-for-large"> <span class="neplus orange-color">&amp;</span> Advocate
                        </h1>
                    </div>
                    <div class="panel__item__content cell medium-6"
                    data-aos="fade-up">
                        <div class="panel__item__content__text panel__item__content__text--white panel__item__content__text--hero">
                            <p>In 1975, SVMIC was created by doctors for doctors and is 100% owned and governed by our members. We provide medical malpractice insurance at a net cost, returning an annual share of profits to members. Physician involvement and physician governance mean that we are able to always keep your interests at heart.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- shapes -->
          <div class="shape shape--hero circle circle--about-top-big"></div>
          <div class="shape shape--hero circle circle--about-top-mid"></div>
          <div class="shape shape--hero circle circle--about-top-small"></div>
          <div class="shape shape--hero circle circle--about-top-blur"></div>
          <div class="triangle-wrap-about-top">
            <div class="shape shape--hero shape--has-bg triangle triangle--about-top"></div>
          </div>
          <div class="shape shape--hero dot dot--about-top"></div>
          <!-- end shapes -->
    </div>
    <div id="our-mission"
         data-aos="fade-in"
         data-aos-duration="400">
      <div class="section-content">
        <div class="grid-container">
          <div class="grid-x align-center">
            <div class="cell medium-10 large-8 xlarge-6">
              <h3 class="our-section-headline">Our Mission</h3>
              <div class="our-hr"></div>
              <p>Protect, support, and advocate for physicians and other healthcare providers.</p>
            </div>
          </div>
        </div>
      </div>
      <div id="logo-outline">
        <img src="../assets/logo-outline.png" alt="">
      </div>
    </div>
    <div id="our-values"
         class="our-section"
         data-aos="fade-in"
         data-aos-duration="400">
      <div class="grid-container">
        <div class="grid-x grid-padding-x align-center">
        <div class="cell medium-10 large-8">
          <h3 class="our-section-headline">Our Values</h3>
          <div class="our-hr"></div>
        </div>
        <ValuesMasterDetail/>
      </div>
      </div>
    </div>
  </DefaultPage>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';
import ValuesMasterDetail from '@/components/master-detail/ValuesMasterDetail';

export default {
  name: 'About',
  components: {
    ValuesMasterDetail,
    DefaultPage
  }
};
</script>
